import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.TRADES_API_URL;
/*
  CREATE
*/
export const postTrade = async ({ user, data }) => {
    try {
        const response = await axios.post(`${API_URL}/`, formatData(user, data));
        return response;
    }
    catch (error) {
        handleError('postTrade', error);
        return error.response;
    }
};
export const alertTrade = async ({ id }) => {
    try {
        const response = await axios.post(`${API_URL}/alert/${id}`);
        return response;
    }
    catch (error) {
        handleError('alertTrade', error);
    }
};
/*
  READ
*/
export const getTrades = async ({ itemNumbers, loadMore }) => {
    const addItemNumbers = itemNumbers ? `&itemNumbers=${itemNumbers}` : '';
    const addLoadMore = loadMore ? `&loadMore=${loadMore}` : '';
    try {
        const response = await axios.get(`${API_URL}/?${addItemNumbers}${addLoadMore}`);
        return response;
    }
    catch (error) {
        handleError('getTrades', error);
        return error.response;
    }
};
export const getTradesByItemNumber = async ({ itemNumber, loadMore }) => {
    const addLoadMore = loadMore ? `&loadMore=${loadMore}` : '';
    try {
        const response = await axios.get(`${API_URL}/itemNumber/${itemNumber}/?${addLoadMore}`);
        return response;
    }
    catch (error) {
        handleError('getTradesByItemNumber', error);
        return error.response;
    }
};
export const getTradesBySearch = async ({ search, itemNumber, loadMore }) => {
    const addLoadMore = loadMore ? `&loadMore=${loadMore}` : '';
    try {
        const response = await axios.get(`${API_URL}/itemNumber/${itemNumber}/search/${search}/?${addLoadMore}`);
        return response;
    }
    catch (error) {
        handleError('getTradesBySearch', error);
        return error.response;
    }
};
/*
  UPDATE
*/
export const putTrade = async ({ user, data }) => {
    try {
        const response = await axios.put(`${API_URL}/${data._id}`, formatData(user, data));
        return response;
    }
    catch (error) {
        handleError('putTrade', error);
    }
};
/*
  DELETE
*/
export const deleteTrade = async ({ id }) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response;
    }
    catch (error) {
        handleError('deleteTrade', error);
    }
};
/*
  UTILITIES
*/
const formatData = (user, data) => {
    const newTrade = {
        itemNumber: data.itemNumber,
        type: data.type,
        headline: data.headline,
        body: data.body,
        extra: [],
        user: user.userService._id,
        sendNotifications: data.sendNotifications
    };
    if (data.option) {
        newTrade.extra.push({
            key: 'option',
            type: 'plain-text',
            value: data.option
        });
    }
    if (data.images) {
        newTrade.extra.push({
            key: 'images',
            type: 'images',
            value: data.images
        });
    }
    if (data.foundBySAM) {
        newTrade.extra.push({
            key: 'foundBySAM',
            type: 'boolean',
            value: data.foundBySAM
        });
    }
    return newTrade;
};
//# sourceMappingURL=Trades.js.map